
export function groupFaq() {
  $('.faq').each(function() {
    const $faq = $(this)
    const $question = $faq.find('.faq__question')
    $question.on('click', function(e){
      e.preventDefault()
      $faq.toggleClass('faq--open')
    })
    if(!$faq.closest('.faq-wrap').length) {
      $faq.nextUntil(':not(.faq)').addBack().wrapAll("<div class='faq-wrap' />")
    }
  })
}
